import { a as __spreadArray, _ as __read } from '../../../tslib.es6-fe064bda.js';

var formatDate = (function () {
    var dateSepRegx = /[/ :.]/g;
    var getDateByFormat = function (date, format) {
        switch (format) {
            case 'DD':
                return date.getDate().toString().padStart(2, '0');
            case 'MM':
                return (date.getMonth() + 1).toString().padStart(2, '0');
            case 'YY':
                return date.getFullYear().toString().substring(2);
            case 'YYYY':
                return date.getFullYear().toString();
            case 'hh':
                return date.getHours().toString().padStart(2, '0');
            case 'mm':
                return date.getMinutes().toString().padStart(2, '0');
            case 'ss':
                return date.getSeconds().toString().padStart(2, '0');
            default:
                return '';
        }
    };
    return function (date, format) {
        if (format === void 0) { format = 'MM.DD.YY hh:mm:ss'; }
        var newDate = date;
        if (typeof date === 'string') {
            var lastSymbol = date.split('').pop();
            /**
             * add Z delete when we have normal backend // newDate new Date(data);
             */
            newDate = new Date("".concat(date).concat(lastSymbol === 'Z' ? '' : 'Z'));
        }
        // @ts-ignore
        var sep = __spreadArray([''], __read(format.match(dateSepRegx)), false);
        return format.split(dateSepRegx).reduce(function (d, f, i) {
            var s = sep[i] || '';
            return "".concat(d).concat(s).concat(getDateByFormat(newDate, f));
        }, '');
    };
})();

export { formatDate };
